<template>
  <div class="form container">
    <div class="form-article formResponsive formHorizontal">
      <div class="form-article-item form-article-item-reviewers">
        <select
          v-model="reviews[0].user_id"
          @change="
            reviews[0].text = '';
            (reviews[0].approved = false), (reviews[0].corrections = false);
          "
        >
          <option disabled value="0">Choose a Reviewer</option>
          <option v-for="user in reviewers" :value="user.id">
            {{ user.username }}
          </option>
        </select>
        <select
          v-model="reviews[1].user_id"
          @change="
            reviews[1].text = '';
            (reviews[1].approved = false), (reviews[1].corrections = false);
          "
        >
          <option disabled value="0">Choose a Reviewer</option>
          <option v-for="user in reviewers" :value="user.id">
            {{ user.username }}
          </option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
import Fragment from "vue-fragment";
import ReviewForm from "./ReviewForm";

export default {
  name: "ReviewersForm",
  components: { Fragment, ReviewForm },
  props: {
    reviews: {
      type: Array,
      default: function () {
        return [];
      },
    },
    reviewers: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
};
</script>

<style lang="scss">
.form-article {
  .form-article-item-reviewers {
    select {
      background-color: #fdee21;
      width: 350px !important;
      margin-bottom: 2em;
      font-size: 1em;
      display: block;
    }
    select:focus {
      background-color: #fff9aa;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ReviewersForm.vue?0b4e1f3a